import React from "react";
import { Sparkles } from "lucide-react";
import SponsorCard from "@/components/sponsors/SponsorCard";
import EmptyState from "@/components/common/EmptyState";
import { Button } from "@/components/ui/button";

/**
 * "Recommended For You" sponsor suggestions, including the empty state.
 *
 * Extracted verbatim from src/pages/Dashboard.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged.
 */
export default function RecommendedSponsors({ recommended, navigate }) {
  return (
    <section>
      <h2 className="font-display text-xl font-bold text-[#1F2A2E]">Recommended For You</h2>
      <p className="mt-1 text-sm text-[#4B5A60]">
        Sponsors in your recovery pathway and area appear first.
      </p>
      {recommended.length === 0 ? (
        <div className="mt-4">
          <EmptyState
            icon={Sparkles}
            testId="recommended-empty"
            title="No suggestions yet"
            description="As more sponsors join, we will surface the ones who best match your pathway, location and preferences."
            action={
              <Button
                onClick={() => navigate("/sponsors")}
                className="bg-[#1F6F78] hover:bg-[#185B62] text-white"
              >
                Browse all sponsors
              </Button>
            }
          />
        </div>
      ) : (
        <div className="mt-4 grid gap-5 sm:grid-cols-2">
          {recommended.slice(0, 4).map((s) => (
            <SponsorCard
              key={s.user_id}
              sponsor={s}
              onMessage={() => navigate(`/sponsors/${s.user_id}`)}
            />
          ))}
        </div>
      )}
    </section>
  );
}
